import { FavouriteIcon } from '@tymbe/ui-icons';
import { ShiftData } from '../../../../types/TymbeApi';
import classNames from 'classnames';

interface ShiftDetailBreadcrumbProps {
  shift?: ShiftData;
}

export const ShiftDetailBreadcrumb = ({ shift }: ShiftDetailBreadcrumbProps) => {
  const breadcrumbClasses = classNames(
    'flex items-center gap-2 text-caption-xl'
  );

  const separatorClasses = classNames(
    'size-4 p-0.5 text-secondary-400 bg-secondary-transparent-5 rounded-sm'
  );

  const textClasses = classNames(
    'truncate'
  );

  return (
    <div className={breadcrumbClasses}>
      <span className={textClasses}>{shift?.company?.name}</span>
      <FavouriteIcon
        name="chevron_right"
        className={separatorClasses}
      />
      <span className={textClasses}>
        {shift?.branchoffice?.parent?.name}
      </span>
      <FavouriteIcon
        name="chevron_right"
        className={separatorClasses}
      />
      <span className={textClasses}>{shift?.branchoffice?.name}</span>
    </div>
  );
};
